import React from "react";

const COMPARISON_DATA = [
    {  us: "Lifetime Warranty.", others: "Limited or no warranty." },
    {  us: "Guaranteed Fit", others: "Loose (or too tight) fit" },
    {  us: "Anti-scratch fleece interior lining", others: "Rough lining causes micro scratches" },
    {  us: "Tough, durable layered materials", others: "Weak materials that rip and don't last" },
    {  us: "Lock and key antitheft", others: "Easily stolen" },
    {  us: "Fast, easy installation", others: "Complex, frustrating installation" },
    {  us: "Blue, grey, black color options", others: "No color options" },
    {  us: "Storm-proof straps", others: "High winds blow them away" },
];

const CarComparisonTable = () => {
    return (
        <div className="table-block table-block--our-tables-vs-others table-block--car-comparison-table">
            <div className="table-block">
                <div className="table-block__header">
                    <div className="table-block__header-cell">Seal Skin Covers</div>
                    <div className="table-block__header-cell table-block__cell--pill">VS</div>
                    <div className="table-block__header-cell">Generic Covers</div>
                </div>

                {COMPARISON_DATA.map((row, index) => (
                    <div className="table-block__row" key={index}>
                        <div className="table-block__cell">{row.us}</div>
                        <div className="table-block__cell">{row.others}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CarComparisonTable;